import React from 'react'
import { useNavigate } from 'react-router-dom';
import { insight } from '../../routes/route';
const { USER_INSIGHT, CONSULTANT_INSIGHT } = insight;
const   InsightManagement = () => {
  const navigate = useNavigate();
    return (
        <div className="container min-vh-100 d-flex justify-content-center align-items-center">
          <div className="row text-center">
            <div className="col-12 mb-4">
              <h1 className="display-4">Insight Management</h1>
              <p className="lead">Choose an option to proceed</p>
            </div>
            <div className="col-md-6 mb-3 block_user_button">
              <button 
                className="btn-lg w-100 py-3" style={{padding: '10px 20px'}}
                onClick={() => navigate(USER_INSIGHT)}
              >
                User Insight
              </button>
            </div>
            <div className="col-md-6 mb-3">
              <button 
                className="btn btn-secondary btn_secondary_btn btn-lg w-100 py-3"
                style={{fontSize: '16px'}}
                  onClick={() => navigate(CONSULTANT_INSIGHT) }
              >
                Consultant Insight
              </button>
            </div>
          </div>
        </div>
      );
}

  export default InsightManagement
